import { createRouter, createWebHistory } from "vue-router";
import {
  breadCrumb,
  closeAllPanels,
  pageTitle,
  panels,
  setCaption,
} from "@/layouts/layouts";

import Bus from "@/core/bus";
import stateStore from "@/store";
import { expandUserRoles } from "@/helpers/roles";

const routes = [
  {
    path: "",
    component: () => import("@/layouts/Panels.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/main/index.vue"),
      },
      {
        path: "/ward-occupancy",
        component: () => import("@/views/ward-occupancy/index.vue"),
      },
      {
        path: "/occupancy-plan",
        component: () => import("@/views/occupancy-plan/index.vue"),
      },
      {
        path: "/hospital-plan",
        component: () => import("@/views/hospital-plan/index.vue"),
      },
      {
        path: "/admin/menu-access",
        component: () => import("@/views/admin/MenuAccess.vue"),
        meta: {
          roles: ["admin"],
        },
      },
      {
        path: "/admin/form-access",
        component: () => import("@/views/admin/FormAccess.vue"),
        meta: {
          roles: ["admin"],
        },
      },
      {
        path: "/ciz",
        component: () => import("@/views/ciz/index.vue"),
        meta: {
          title: "ЦИСЗ",
          roles: ["admin"],
        },
      },
      {
        path: "/ciz/oauth/callback",
        component: () => import("@/views/ciz/OauthCallback.vue"),
        meta: {
          title: "ЦИСЗ — вход",
        },
      },
      {
        path: "/ciz/oauth/done",
        component: () => import("@/views/ciz/OauthDone.vue"),
        meta: {
          title: "ЦИСЗ — вход выполнен",
        },
      },
      {
        path: "/webinars",
        component: () => import("@/tables/webinars/List/index.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "market_user",
            "nurse",
            "chief_medical",
            "manager",
            "medical_doctor",
            "telemedicine",
            "warehouse",
            "warehouse2",
          ],
        },
      },
      {
        path: "/dbform",
        component: () => import("@/views/dbform/index.vue"),
        meta: {
          title: "DB-form",
        },
      },
      {
        path: "/select",
        component: () => import("@/views/Testings/Select.vue"),
        meta: {
          title: "Компонент выбора",
        },
      },
      {
        path: "/comments",
        component: () => import("@/views/Testings/Comments.vue"),
        meta: {
          title: "Комментарии",
        },
      },
      {
        path: "/printbarcodes",
        component: () => import("@/views/PrintBarcodes.vue"),
        meta: {
          title: "Печать штрих-кодов",
        },
      },
      {
        path: "/demo1",
        component: () => import("@/views/Testings/Demo1.vue"),
        meta: {
          title: "Demo 1",
        },
      },
      {
        path: "/development",
        component: () => import("@/views/Testings/Development.vue"),
        meta: {
          title: "Development",
        },
      },
      {
        path: "/css_test",
        component: () => import("@/views/Testings/css.vue"),
        meta: {
          title: "CSS",
        },
      },
      {
        path: "/reports",
        component: () => import("@/reports/index.vue"),
      },
      {
        path: "/reports/open/:report",
        component: () => import("@/views/ReportOpen.vue"),
        meta: {
          title: "Отчёт",
        },
      },
      {
        path: "/stub/:slug?",
        component: () => import("@/views/MenuStub.vue"),
        meta: {
          title: "Раздел в разработке",
        },
      },
      {
        path: "/reports/medicament-inventory",
        component: () => import("@/reports/medicament_inventory/index.vue"),
        meta: {
          title: "Отчет по складскому учету лекарственных средств",
          roles: ["admin", "warehouse", "warehouse2"],
        },
      },
      {
        path: "/medicament_stock",
        component: () => import("@/tables/medicament_stock/forms/List.vue"),
        meta: {
          title: null,
          roles: ["admin", "warehouse", "warehouse2", "duty", "chief_medical", "manager"],
        },
      },
      {
        path: "/publications/:guid",
        component: () => import("@/views/Publication.vue"),
        meta: {
          title: "",
        },
      },
      {
        path: "/help",
        component: () => import("@/views/Help.vue"),
        meta: {
          title: "Помощь",
        },
      },
      {
        path: "/inspection_patients",
        component: () => import("@/views/inspection_patients/index.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "patients",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/inspection_med_histor",
        component: () => import("@/views/inspection_med_histor/index.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "patients",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/patients",
        component: () => import("@/tables/patients/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "patients",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/patients/:id",
        component: () => import("@/tables/patients/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "patients",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/extract_list",
        component: () => import("@/tables/extract_list/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/outpatient_appointment",
        component: () =>
          import("@/tables/outpatient_appointment/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/patients_cards",
        component: () => import("@/tables/patients_cards/List/index.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/nursing-rounds",
        component: () => import("@/views/NursingRounds.vue"),
        meta: {
          title: "Сестринский обход",
          roles: ["admin", "nurse"],
        },
      },
      {
        path: "/doctor-rounds",
        component: () => import("@/views/DoctorRounds.vue"),
        meta: {
          title: "Врачебный обход",
          roles: ["admin", "medical_doctor", "chief_medical"],
        },
      },
      {
        path: "/chatgpt",
        component: () => import("@/tables/chatgpt/index.vue"),
        meta: {
          roles: ["admin"],
        },
      },
      {
        path: "/appointment_research",
        component: () => import("@/tables/appointment_research/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/instrumental_research",
        component: () => import("@/tables/instrumental_research/forms/List.vue"),
        meta: {
          title: "Журнал инструментальных исследований",
          roles: [
            "admin",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/prescription-execution-journal",
        component: () =>
          import("@/tables/appointment_drugs/forms/List.vue"),
        meta: {
          title: "Журнал выполнения врачебных назначений",
          roles: [
            "admin",
            "nurse",
            "duty",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/appointment_procedure",
        component: () =>
          import("@/tables/appointment_procedure/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/dentist",
        component: () => import("@/tables/dentist/forms/List.vue"),
        meta: {
          roles: ["admin"],
        },
      },
      {
        path: "/patients_cards/:id",
        component: () => import("@/tables/patients_cards/List/index.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/vkk",
        component: () => import("@/tables/vkk/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/vkk/:id",
        component: () => import("@/tables/vkk/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/temporary_disability",
        component: () => import("@/tables/temporary_disability/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/temporary_disability/:id",
        component: () => import("@/tables/temporary_disability/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/temporary_disability/edit/:id",
        component: () => import("@/tables/temporary_disability/forms/Edit.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/ln_sheets",
        component: () => import("@/tables/ln_sheets/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/ln_sheets/:id",
        component: () => import("@/tables/ln_sheets/forms/List.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/ln_sheets/edit/:id",
        component: () => import("@/tables/ln_sheets/forms/Edit.vue"),
        meta: {
          roles: [
            "admin",
            "duty",
            "nurse",
            "market_user",
            "medregistrator",
            "chief_medical",
            "manager",
            "medical_doctor",
          ],
        },
      },
      {
        path: "/tables",
        component: () => import("@/views/ViewTables.vue"),
        meta: {
          title: "Список таблиц",
          roles: ["admin", "market_user"],
        },
      },
      {
        path: "/tables/:table",
        component: () => import("@/tables/List.vue"),
        meta: {
          title: "Таблица",
        },
      },
      {
        path: "/about",
        component: () => import("@/views/About.vue"),
        meta: {
          title: "О портале",
        },
      },
      {
        path: "/messages",
        component: () => import("@/views/messages.vue"),
        meta: {
          title: "Сообщения",
        },
      },
      {
        path: "/icons",
        component: () => import("@/views/Icons.vue"),
        meta: {
          title: "Иконки - DevaresStationar",
        },
      },
    ],
  },
  {
    path: "/profile",
    component: () => import("@/views/profile/index.vue"),
    meta: {
      title: "Профиль",
      breadCrumb: [
        {
          route: "/profile",
          icon: "icon icon-user",
          caption: "Профиль",
        },
      ],
    },
    children: [
      {
        path: "",
        component: () => import("@/views/profile/page.vue"),
        meta: {
          title: "Основные данные",
          icon: "icon icon-more-horizontal",
          breadCrumb: [
            {
              route: "/profile",
              icon: "icon icon-user",
              caption: "Профиль",
            },
            {
              icon: "icon icon-book-open",
              caption: "Основные данные",
            },
          ],
        },
      },
      {
        path: "page",
        component: () => import("@/views/profile/page.vue"),
        meta: {
          title: "Основные данные",
          icon: "icon icon-book-open",
          breadCrumb: [
            {
              route: "/profile",
              icon: "icon icon-user",
              caption: "Профиль",
            },
            {
              icon: "icon icon-book-open",
              caption: "Основные данные",
            },
          ],
        },
      },
      {
        path: "equipment",
        component: () => import("@/views/profile/equipment.vue"),
        meta: {
          title: "Оборудование",
          icon: "icon icon-printer",
          breadCrumb: [
            {
              route: "/profile",
              icon: "icon icon-user",
              caption: "Профиль",
            },
            {
              icon: "icon icon-printer",
              caption: "Оборудование",
            },
          ],
        },
      },
    ],
  },
  {
    path: "/user/:guid",
    component: () => import("@/views/UserProfile/index.vue"),
    meta: {
      title: "Профиль",
    },
    children: [
      {
        path: "",
        component: () => import("@/views/UserProfile/AboutUser.vue"),
        meta: {
          title: "О пользователе",
          icon: "icon-user",
        },
      },
      {
        path: "aboutuser",
        component: () => import("@/views/UserProfile/AboutUser.vue"),
        meta: {
          title: "О пользователе",
          icon: "icon-user",
        },
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/views/auth/Login.vue"),
    meta: {
      layout: "empty-layout",
    },
  },
  {
    path: "/404",
    component: () => import("@/views/Page404.vue"),
  },
  {
    path: "/:pathMatch(.*)",
    component: () => import("@/views/Page404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export const openRoute = (path: string) => {
  const currentRoute = router.currentRoute.value.path
    .split("/")
    .filter((el) => el);
  const newRoute = path.split("/").filter((el) => el);

  if (
    currentRoute.length > 0 &&
    newRoute.length > 0 &&
    currentRoute[0] == newRoute[0]
  ) {
    router.replace(path);
  }
};

Bus.$on("ws-open-document", (data: any) => {
  switch (data.type_document) {
    default:
      // console.log(data);

      // router.push(`pgi_research/${data.id}`);

      break;
  }
});

router.beforeEach(async (to, from) => {
  //Прописывать в роутах роли и проверять доступ при переходах
  if (to.fullPath != from.fullPath) {
    const hasProcessingPanel = panels.value.some((p: any) => (p as any)._processingReceipt === true);
    if (hasProcessingPanel) {
      return false;
    }

    if (!(await closeAllPanels())) return false;

    setCaption("");
  }

  // Проверяем, не является ли целевой маршрут страницей логина
  if (to.path === "/login") {
    return true;
  }

  //Получаем статус пользователя
  const user: any = stateStore.state.user.id
    ? stateStore.state.user
    : await stateStore.dispatch("status");

  // Если пользователь не авторизован (нет id), перенаправляем на логин
  if (!user.id) {
    return { path: "/login" };
  }

  //Если в метаданных прописаны роли, то производим проверку на доступ, если не указана ни одна роль - доступ запрещен
  if (to.meta.roles) {
    const roles: any = to.meta.roles;
    const userRoles = expandUserRoles(user.roles || []);

    for (const routeRole of roles) {
      if (userRoles.includes(routeRole)) return true;
    }

    return { path: "/404" };
  } else {
    return true;
  }
});

router.afterEach((to) => {
  breadCrumb.value = to.meta.breadCrumb ? to.meta.breadCrumb : [];

  pageTitle.value = to.meta.title ? to.meta.title : null;
});

export default router;
